import { V2_AGREE_LAYOUT_TYPE } from "@/types/layout";
import { NextPage } from "next";
import AgreementHeader from "./agree-header";

export interface IAgreeLayoutProps {
  Page: NextPage;
  layoutType: V2_AGREE_LAYOUT_TYPE;
}

const AgreeLayout = ({ Page, layoutType }: IAgreeLayoutProps) => {
  return layoutType === "DEFAULT" ? (
    <div className="v2override">
      <AgreementHeader />
      <section className="site-layout-content-simple mt-[54px] lg:mt-[70px]">
        <Page />
      </section>
    </div>
  ) : (
    <></>
  );
};

export const getAgreeLayout = (layoutType: V2_AGREE_LAYOUT_TYPE) => {
  const editorLayout = (Page: NextPage, props: Record<string, unknown>) => (
    <AgreeLayout layoutType={layoutType} {...props} Page={Page} />
  );

  return editorLayout;
};

export default AgreeLayout;
